export default __webpack_public_path__ + "static/media/kaaf-hire-banner.18b87ee7.png";